import { EventEmitter, Injectable } from "@angular/core";

@Injectable()
export class EventService {
  public eventBus = new EventEmitter<{ event: string; data?: any }>();

  constructor() {}
}
